/** Notice image upload limits (keep in sync with Storage bucket + RPC). */
export const NOTICE_IMAGES_BUCKET = 'notice-images';
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;
export const MAX_IMAGES_PER_NOTICE = 99;
export const IMAGE_MAX_EDGE_PX = 1920;
export const IMAGE_JPEG_QUALITY = 0.82;
export const SIGNED_URL_EXPIRES_SEC = 60 * 60;
/** Edge `sign-notice-images` の1リクエスト上限（製品上限 99 以上）。 */
export const SIGNED_URL_BATCH_MAX_PATHS = 99;
